export default __webpack_public_path__ + "static/media/section1-bg.17a898db.png";